const gsap = window.app.gsap

const HomeIntro = class {
  constructor() {
    this.container = document.getElementsByClassName('home-intro')[0]
    this.animated = false
    this.toPreload = document.querySelectorAll('div[data-background-img]')
    this.loadedImages = 0
    this.heroProgressOver60 = false
    this.preloadImages()
  }

  preloadImages() {
    this.toPreload.forEach(el => {
      const imageUrl = el.dataset.backgroundImg
      let preloader = document.createElement('img')

      preloader.src = imageUrl

      preloader.addEventListener('load', () => {
        el.style.backgroundImage = `url(${imageUrl})`
        this.loadedImages++
        preloader = null

        if (this.loadedImages === this.toPreload.length) {
          this.setupScrollAnimation()
          this.animateIn()
          document.dispatchEvent(new CustomEvent('assetsLoaded', { detail: 'home-intro' }))
        }
      })
    })
  }

  animateIn() {
    if (this.container) {
      if (window.scrollY > 140) this.container.dataset.animationInstant = 1
      this.container.dataset.animationState = 1
      this.animated = true
    }
  }

  setupScrollAnimation() {
    if (this.container) {
      const secondaryHeroes = document.querySelectorAll('.home-intro__hero-left, .home-intro__hero-right')
      gsap.to(secondaryHeroes, {
        translateX: 0,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: this.container,
          start: 'top top',
          end: '+=30%',
          scrub: 1
        }
      })

      const tertiaryHeroes = document.querySelectorAll('.home-intro__hero-leftmost, .home-intro__hero-rightmost')
      gsap.to(tertiaryHeroes, {
        translateX: 0,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: this.container,
          start: 'top top',
          end: '+=35%',
          scrub: 1,
          onUpdate: (self) => {
            if (self.progress > 0.6 && !this.heroProgressOver60) {
              this.heroProgressOver60 = true
              const heroRoot = self.trigger.getElementsByClassName('home-intro__hero')[0]
              heroRoot.classList.add('home-intro__hero--show-badge')
            } else if (self.progress <= 0.6 && this.heroProgressOver60) {
              this.heroProgressOver60 = false
              const heroRoot = self.trigger.getElementsByClassName('home-intro__hero')[0]
              heroRoot.classList.remove('home-intro__hero--show-badge')
            }
          }
        }
      })

      // Add animation for the new quaternary heroes (far-left, far-right)
      const quaternaryHeroes = document.querySelectorAll('.home-intro__hero-far-left, .home-intro__hero-far-right')
      gsap.to(quaternaryHeroes, {
        translateX: 0,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: this.container,
          start: 'top top',
          end: '+=40%', // Longer scroll distance for farther bottles
          scrub: 1
        }
      })

      const heading = document.getElementsByClassName('home-intro__heading')[0]
      gsap.set(heading, { xPercent: -50, yPercent: -50 })
      gsap.to(heading, {
        yPercent: -80,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: this.container,
          start: '80px top',
          end: '+=50%',
          scrub: 1
        }
      })
    }
  }
}

new HomeIntro()
